import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import SidebarItem from '~/components/atoms/SidebarItem';
import { SideBarItemType } from '~/core/sidebar';
import { checkIsAbsolutePath, checkIsRouteMatch } from '~/helpers/routeMatcher';

import styles from '../styles.module.scss';

type Props = {
  items: SideBarItemType[][];
};

const MainLayoutSidebarDesktop: FC<Props> = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebar__items}>
        {items.map((items, i) => (
          <div key={i}>
            {items.map(
              ({
                path,
                getRedirectPath,
                Icon,
                getTitle,
                getLabel,
                onClickCb,
              }) => (
                <SidebarItem
                  isActive={checkIsRouteMatch(path, location.pathname)}
                  key={path}
                  Icon={Icon}
                  onClick={(): void => {
                    onClickCb && onClickCb();
                    const redirectPath = getRedirectPath && getRedirectPath();
                    if (redirectPath && checkIsAbsolutePath(redirectPath)) {
                      window.setTimeout(() => {
                        // timeout for correct working analytics
                        window.location.href = redirectPath;
                      }, 100);
                    } else {
                      navigate(redirectPath || path);
                    }
                  }}
                  title={getTitle(t)}
                  {...(getLabel ? { label: getLabel(t) } : {})}
                />
              ),
            )}
          </div>
        ))}
      </div>
    </aside>
  );
};

export default MainLayoutSidebarDesktop;
